import PropTypes from 'prop-types'
import { ObjectColors } from '../../models/vehicle/object-colors-enum'

/**
 * @typedef {string} ObjectColor
 */
export const objectColorPropType = PropTypes.oneOf(Object.values(ObjectColors))
